import { gql } from '@apollo/client';

export const UPDATE_USER_PREFERENCES = gql`
  mutation updateUserPreferences($input: PreferencesInput!) {
    updateUserPreferences(input:$input) {
      language {
        code
        name
      }
      community {
        distance
        metricType
        placeId
        address
        localArea
        location {
          lat
          lng
        }
        isSaved
        flyerCounters {
          name
          frequency
          amount
        }
      }
      disclaimer {
        version
        acceptedAt
      }
    }
  }
`
